import React from "react";
import {connect} from 'react-redux'
import {Field, reduxForm, Form as RForm} from 'redux-form'
import CustomSelect from "views/Components/CustomSelect.jsx"
import ValidatedCustomInput from "views/Components/ValidatedCustomInput.jsx"
import {required} from 'views/utils/validations'
// @material-ui/icons
//import MoreIcon from "@material-ui/icons/More";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import RoomIcon from "@material-ui/icons/Room";


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import NavPills from "components/NavPills/NavPills.jsx";

// import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from '@material-ui/core/LinearProgress';

//ibs
import {
  accountSave,
  accountSaveReassign,
  accountsFetch,
  accountFetch,
  setAccountClient
} from 'actions/accounts'
import {
  plaformsFetch
} from 'actions/platforms'
import {
  currenciesFetch,
  currencyFilter
} from 'actions/currencies'

import {
  danger,
  success,
} from 'actions/notification'

import {
  clientsFetchAll
} from 'actions/clients'

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";

class Form extends React.Component {
  state={
    clientId:0
  }
  componentDidMount(){
    this.props.platformsFetch()
    this.props.currencyFilter({size: 100000})
    this.props.currenciesFetch()
    this.props.clientsFetch();
    
    //Fetch information if is edit form
    if(this.props.match.params.id) {
    this.props.fetch(this.props.match.params.id)
      .then(e=> {
        this.props.initialize({...e, platformId: e.platform.platformId, currencyId: e.currency.currencyId})
        this.setState({
            clientId: e.clientId
          });
      })
    } else {
      if(this.props.accounts.selectedClientId) {
        this.props.initialize({clientId: this.props.accounts.selectedClientId})
      }
    }
  }
  getInput(data) {
    return <Field
            name={data.key}
            placeholder={data.name}
            id={data.key}
            icon={data.icon}
            props={{
              name: data.key
            }}
            validate={data.required ? [required] : []}
            component={ValidatedCustomInput}
          />
  }
  //Submit form
  submit(values){
    this.props.save(values).then(e=>{

      if (this.props.match.params.id) {
    
        values.newClientId = values.clientId;

        this.props.saveReassign(values).then(event=>{

          
        
        });

      }

      this.props.success(e.number+ ' '+(this.props.match.params.id?'Edited':'Added')+'!',4);
      this.props.clientsFetch();
      this.props.history.goBack()

      })
      .catch(e=>{this.props.danger(e+'',4);})
  }
  //OnChange action for all inputs and selects
  change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
  }

  render() {
    const {classes, isFetching, platforms, currencies, handleSubmit, clients}=this.props;
    const editMode = this.props.match.params.id
    const {clientId} = this.state;
    return (
          <GridContainer justify="center">
            <GridItem xs={12} sm={8}>
            <Card>
            <CardBody>
            {//Show progress onFetch
            (isFetching)         
            ?<LinearProgress/>
            :<RForm onSubmit={handleSubmit(this.submit.bind(this))}>
              <GridContainer justify="center">
                {/*Header Information*/}
            <NavPills
                  color="primary"
                   Vertical={{
                    tabsGrid: { xs: 12, sm: 12, md: 4 },
                    contentGrid: { xs: 12, sm: 12, md: 8 }
                  }}
                  tabs={[
                    {
                      tabButton: "Account Details",
                      tabContent: (
                        <GridContainer justify="center" style={{width: '99%'}}>
                          
                          <GridItem xs={12} sm={12}>
                    <h4 className={classes.infoText}>
                      Complete information
                    </h4>
                  </GridItem>
                  {!editMode &&
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      {this.getInput({
                        key:'clientId',
                        name:'Client Id *',
                        icon:<RecordVoiceOverIcon className={this.props.classes.inputAdornmentIcon}/>,
                        type:'text',
                        required:true
                        })
                      }
                    </GridItem>
                  }
                  {editMode &&
                    <GridItem xs={12} sm={12} md={12} lg={10}>
                      {
                        <span>Client ID: {clientId}</span>
                      }
                    </GridItem>
                  }
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    {this.getInput({
                      key:'number',
                      name:'Number *',
                      icon:<RoomIcon className={this.props.classes.inputAdornmentIcon}/>,
                      type:'text',
                      required:true
                      })
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <Field
                      name="platformId"
                      options={platforms.map((i) => {return {value: i.platformId, label: i.name}})}
                      placeholder="Platform *"
                      id="platformId"
                      props={{
                        name:"platformId"
                      }}
                      validate={[required]}
                      component={CustomSelect}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <Field
                      name="currencyId"
                      options={currencies.map((i) => {return {value: i.currencyId, label: i.name}})}
                      placeholder="Currency *"
                      id="currencyId"
                      props={{
                        name:"currencyId"
                      }}
                      validate={[required]}
                      component={CustomSelect}
                    />
                  </GridItem>

                       </GridContainer>
                      )
                    },
                    ((editMode)?
                      {
                        tabButton: "Reassign Client",
                        tabContent: (
                          <GridContainer justify="center" style={{width: '99%'}}>
                           
                            
                                <GridItem xs={12} sm={12} md={12} lg={10}>
                                  <Field
                                    name="clientId"
                                    label="Select Client"
                                    options={clients.map((i) => {return {value: i.clientId, label: i.name+' ('+i.clientId+') '}})}
                                    placeholder="Client *"
                                    id="clientId"
                                    props={{
                                      name:"clientId"
                                    }}
                                    validate={[required]}
                                    component={CustomSelect}
                                  />
                                </GridItem>
                     
                          </GridContainer>
                        )
                      }:{}
                  )
                  ]}
                />
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <Button
                      type="submit"
                      className={classes.submit}
                      color="success">Submit</Button>
                  </GridItem>
              </GridContainer>
              </RForm>
            }
              </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
    );
  }
}
const mapStateToProps=(state,props)=>({
  isFetching:state.ibs.isFetching,
  platforms: state.platforms.list,
  currencies: state.currencies.list,
  accounts: state.accounts,
  clients: state.clients.list
})
const mapDispatchToProps=(dispatch)=>({
  fetch:(id)=>dispatch(accountFetch(id)),
  fetchAll:()=>dispatch(accountsFetch()),
  setAccountClient: (data) => dispatch(setAccountClient(data)),
  save:(data)=>dispatch(accountSave(data)),
  saveReassign:(data)=>dispatch(accountSaveReassign(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  success:(text,sec)=>dispatch(success(text,sec)),
  clientsFetch: () => dispatch(clientsFetchAll()),
  platformsFetch: () => dispatch(plaformsFetch()),
  currenciesFetch: () => dispatch(currenciesFetch()),
  currencyFilter: (filter) => dispatch(currencyFilter(filter))
})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'createEditAccountForm' })(Form)))



// WEBPACK FOOTER //
// ./src/views/Accounts/Form.jsx